import { combineReducers } from 'redux';
import selectedData from './selectedData';
import initData from './initRegistrationData';
import panels from './registrationFormPanels';
import slotsData from './slotsData';
import wallet from './wallet';
import finishRegistrationData from './finishRegistrationData';

export default combineReducers({
  selectedData,
  initData,
  panels,
  slotsData,
  wallet,
  finishRegistrationData,
});
